import React, { Component } from 'react';
import {Modal, Form, Table, Button, Input, Tooltip} from 'antd';
import http from '../../../axios/http';
const {confirm} = Modal;

const columns = [
    {
        title: '用户名',
        dataIndex: 'username',
        width: 150 },
    {
        title: '名称/姓名',
        dataIndex: 'name',
        width: 150 },
    {
        title: '用户类型',
        dataIndex: 'type',
        render: text => ({0: '普通员工', 1: '开票人员', 2: "代办", 3: '租户', 4: "商城用户"}[text])
    },
    {
        title: '电话',
        dataIndex: 'tel',
        render: (text) => (
            <Tooltip placement="topLeft" title={text}>
                {text}
            </Tooltip>
        )
    },
    {
        title: '状态',
        dataIndex: 'state',
        render: text => ({0: '正常', 1: '删除', 2: '停用'}[text])
    },
    {
        title: '所属公司',
        dataIndex: 'memberName',
        render: (text) => (
            <Tooltip placement="topLeft" title={text}>
                {text}
            </Tooltip>
        ), }
];

class RoleUserAddModel extends Component {
    state = {
        tableData: [],
        loading: false,
        selectedRowKeys: [],
        query: {}
    };

    // 每次打开 Modal 自动刷新表格
    componentDidUpdate(prevProps) {
        if (!prevProps.visible && this.props.visible) {
            this.fetchTableData();
            this.setState({ selectedRowKeys: [] }); // 清空选中
        }
    }

    fetchTableData = (page = 1, pageSize = 10) => {
        this.setState({ loading: true });
        // 模拟接口请求，可以替换成真实接口
        http.get({
            url: '/roleUser/findUserByNERoleIdPage',
            data: {roleId: this.props.roleId, pageNumber: page, pageSize: pageSize, ...this.state.query},
            success: res => {
                const { content, totalElements, pageSize, pageNumber } = res;

                this.setState({
                    // tableData: content.map(item => ({ ...item, key: item.id })), // antd 要有 key
                    tableData: (content || []).map(item => ({
                        ...item,
                        key: item.username
                    })),
                    loading: false,
                    pagination: {
                        current: pageNumber,
                        pageSize: pageSize,
                        total: totalElements,
                    }
                });
            },
            error: () => {
                this.setState({ loading: false });
            }
        });
    };

    onSelectChange = selectedRowKeys => {
        this.setState({ selectedRowKeys });
    };

    handleSearch = e => {
        e.preventDefault();
        const { form } = this.props;
        form.validateFields((err, values) => {
            if (!err) {
                this.setState({ query: values }, this.fetchTableData);
            }
        });
    };

    save = () => {
        const { selectedRowKeys } = this.state;
        const { form, roleId } = this.props;
        if (selectedRowKeys.length === 0) {
            return;
        }
        console.log(selectedRowKeys)

        confirm({
            title: '是否保存将所选用户添加到角色？',
            content: selectedRowKeys.join(','),
            onOk:()=>{

                form.validateFields((err, values) => {
                    if (err) return;
                    values.roleId = roleId;
                    values.usernames = selectedRowKeys.join(',');

                    http.post({
                        url: '/roleUser/addUserToRole',
                        data: values,
                        success: () => {
                            if (this.props.successCallback) this.props.successCallback();
                            if (this.props.onCancel) this.props.onCancel();
                        }
                    });
                });
            },
            onCancel() {
                console.log('Cancel');
            },
        });




    };

    render() {
        const { visible, onCancel, form } = this.props;
        const { tableData, loading, selectedRowKeys } = this.state;

        const rowSelection = {
            selectedRowKeys,
            onChange: this.onSelectChange
        };

        const hasSelected = selectedRowKeys.length > 0;

        return (
            <Modal
                visible={visible}
                title="添加用户到角色"
                okText="保存"
                cancelText="取消"
                maskClosable={false}
                onCancel={onCancel}
                onOk={this.save}
                afterClose={() => form.resetFields()}
                width={800}
            >
                {/* 查询表单 */}
                <Form layout="inline" onSubmit={this.handleSearch} style={{ marginBottom: 16 }}>
                    <Form.Item label="用户名">
                        {form.getFieldDecorator('username')(<Input allowClear placeholder="请输入用户名" />)}
                    </Form.Item>
                    <Form.Item label="姓名">
                        {form.getFieldDecorator('name')(<Input allowClear placeholder="请输入姓名" />)}
                    </Form.Item>
                    <Form.Item>
                        <Button type="primary" htmlType="submit">
                            查询
                        </Button>
                    </Form.Item>
                </Form>
                <span style={{marginLeft: 8}}>
                    {hasSelected ? `已选 ${selectedRowKeys.length} 个用户` : ''}
                  </span>

                {/* 表格 */}
                <Table
                    rowSelection={rowSelection}
                    columns={columns}
                    dataSource={tableData}
                    loading={loading}
                    scroll={{ y: 450 }}
                    pagination={{
                        ...this.state.pagination,
                        showSizeChanger: true,
                        showQuickJumper: true,
                        onChange: (page, pageSize) => this.fetchTableData(page, pageSize),
                        onShowSizeChange: (current, size) => this.fetchTableData(current, size),
                    }}
                />
            </Modal>
        );
    }
}

export default Form.create()(RoleUserAddModel);
